import { useNavigate } from "react-router-dom";

// Fade the page out (.fx-out), then client-side navigate; SiteShell fades the next route in
const useTransitionTo = () => {
  const navigate = useNavigate();
  return (path: string) => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const site = document.querySelector(".site");
    if (!site || reduce) { navigate(path); return; }
    site.classList.remove("fx-in");
    site.classList.add("fx-out");
    setTimeout(() => navigate(path), 300);
  };
};

export default useTransitionTo;
